<template>
    <div class="uploadButton" @click="showFileDialog">
        <input type="file" @change="fileSelected($event)" :accept="limitFileBrowser" multiple>
        <slot></slot>
    </div>
</template>

<script>
    export default {
    name: "file-button",
    props: {
      value: {
        type: Array,
        required: true
      },
      fileStatus: {
        type: Object,
        required: false,
        default: () => ({})
      },
      maxFiles: {
        type: Number,
        default: () => Infinity
      },
      showFileDialogEvent: {
        type: String,
        default: () => null
      },
      validTypes: {
        type: Array,
        default: null
      },
      limitFileBrowser: {
        type: String,
        default: null
      }
    },
    data: () => {
      return {
        // LOADING,
        // READY,
        // ERROR
      };
    },
    mounted() {
      if (this.showFileDialogEvent !== null) {
        global.eventHub.$on(this.showFileDialogEvent, () => this.showFileDialog());
      }
    },
    methods: {
      iconClass(file) {
        return 'fa ' + (file.name ? file.name : fileIcon);
      },
      removeUpload(index) {
        this.value.splice(index, 1);
      },
      showFileDialog() {
        this.$el.querySelector('input').click();
      },
      fileSelected(event) {
        var fileList = event.target.files;
        let value = _.cloneDeep(this.value);

        Object.keys(fileList).forEach((key) => {
          if (this.validTypes === null || _.indexOf(this.validTypes, fileList[key].type) >= 0) {
            value.push(fileList[key]);
          }
        });

        this.$emit('input', value);
      },
      _get(obj, path) {
        return _.get(obj, path);
      },
      _has(obj, path) {
        return _.has(obj, path);
      }
    },
    filters: {
      fileIcon(fileName) {
        var extension = fileName.substring(_.lastIndexOf(fileName,'.'));

        switch (extension) {
          case '.xlsx':
          case '.xls':
          case '.csv':
            return 'fa-file-excel-o';
            break;
          case '.docx':
          case '.doc':
            return 'fa-file-word-o';
            break;
          case '.pdf':
            return 'fa-file-pdf-o';
            break;
          default:
            return 'fa-file-o';
            break;
        }
      }
    }
  }
</script>

<style scoped>
    .uploadButton input{
        display: none;
    }
</style>